(function(){
  function clamp(n,min,max){return Math.max(min,Math.min(max,n));}

  async function openNativeSideCart(){
    try{
      var cartStore=window.Alpine&&typeof window.Alpine.store==='function' ? window.Alpine.store('cart') : null;
      if(cartStore){
        if(typeof cartStore.getCardItems==='function') await cartStore.getCardItems();
        if(typeof cartStore.openMiniCart==='function'){
          cartStore.openMiniCart();
          return true;
        }
      }
    }catch(e){}

    var cartTrigger=document.querySelector('[aria-label="cart"], [aria-label="Cart"], [data-cart-drawer-trigger], [data-cart-toggle]');
    if(cartTrigger){
      cartTrigger.click();
      return true;
    }
    return false;
  }

  function init(card){
    if(card.dataset.lpInit==='1') return;
    card.dataset.lpInit='1';
    var qty=card.querySelector('[data-lp-powder-qty]');
    var status=card.querySelector('[data-lp-powder-status]');
    var add=card.querySelector('[data-lp-powder-add]');
    var gifts=Array.from(card.querySelectorAll('[data-lp-powder-gift]'));
    function selectGift(el){
      gifts.forEach(function(g){g.classList.toggle('is-selected',g===el);g.setAttribute('aria-pressed',g===el?'true':'false');});
      card.dataset.selectedGift=el ? el.dataset.variant : '';
      card.dataset.selectedGiftLabel=el ? el.dataset.label : '';
    }
    gifts.forEach(function(g){g.addEventListener('click',function(){selectGift(g);});});
    if(gifts.length) selectGift(gifts.find(function(g){return g.classList.contains('is-selected');})||gifts[0]);
    card.querySelectorAll('[data-lp-powder-qty-change]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var current=parseInt(qty.value||'1',10);
        qty.value=clamp(current+parseInt(btn.dataset.lpPowderQtyChange,10),1,10);
      });
    });
    if(qty){qty.addEventListener('change',function(){qty.value=clamp(parseInt(qty.value||'1',10),1,10);});}
    if(!add) return;
    add.addEventListener('click',async function(){
      var master=add.dataset.masterVariant;
      var gift=card.dataset.selectedGift;
      if(!master){if(status) status.textContent='Select the master product in the Theme Editor.';return;}
      if(!gift){if(status) status.textContent='Please choose your free tablets.';return;}
      add.disabled=true;if(status) status.textContent='';
      try{
        var response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[
          {id:Number(master),quantity:Number(qty.value||1),properties:{'_preorder_campaign':'Powder launch'}},
          {id:Number(gift),quantity:1,properties:{'_free_gift':'Powder preorder','Gift choice':card.dataset.selectedGiftLabel||''}}
        ]})});
        var data=await response.json();
        if(!response.ok) throw new Error(data.description||data.message||'Unable to add products to cart.');
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:data}));

        var afterAdd=card.dataset.afterAdd||'drawer';
        if(afterAdd==='stay'){
          if(status) status.textContent=card.dataset.addedLabel||'Added to cart.';
          add.disabled=false;
        }else if(afterAdd==='cart'){
          window.location.href='/cart';
        }else{
          var opened=await openNativeSideCart();
          if(opened){
            if(status) status.textContent=card.dataset.addedLabel||'Added to cart.';
            add.disabled=false;
          }else{
            window.location.href='/cart';
          }
        }
      }catch(e){if(status) status.textContent=e.message;add.disabled=false;}
    });
  }
  function boot(){document.querySelectorAll('[data-lp-powder-card]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();